'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ReactPlaceholder = require('./ReactPlaceholder');

var _ReactPlaceholder2 = _interopRequireDefault(_ReactPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReactPlaceholder2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-placeholder/lib/index.js
// module id = 2785
// module chunks = 0